/* istanbul ignore file */
import { SCHEDULE_MODES } from '../constants';

export default {
  interviewType: {
    type: 'string',
    required: true,
  },
  interviewMethod: {
    type: 'string',
    required: true,
  },
  scheduleMode: {
    type: 'string',
    required: true,
  },
  interviewer: {
    type: 'string',
    required: {
      value: true,
      when: { $scheduleMode: { in: [SCHEDULE_MODES.SELF_BOOKING_SELECTED, SCHEDULE_MODES.MANUAL] } },
      message: 'Please select the interviewer',
    },
  },
  interviewDateTime: {
    type: 'string',
    required: {
      value: true,
      when: { $scheduleMode: { eq: SCHEDULE_MODES.MANUAL } },
      message: 'Please select the interview date and time',
    },
  },
};
